import { useEffect, useState } from "react";
import { api } from "./api";

// Shared, cached firm branding (logo + name) so the console header, sign-in and
// client portal all stay in sync without refetching on every mount.
let _cache = null;
let _promise = null;
const _subs = new Set();

export const DEFAULT_TIMEZONE = "America/Toronto";
const EMPTY = { logo: "", login_logo: "", name: "", favicon: "", timezone: DEFAULT_TIMEZONE };

const _pick = (b) => ({ logo: b?.logo || "", login_logo: b?.login_logo || "", name: b?.name || "", favicon: b?.favicon || "", timezone: b?.timezone || DEFAULT_TIMEZONE });

// Firm-wide IANA time zone used to render every clock time in the app (default Eastern).
export const getAppTimezone = () => _cache?.timezone || DEFAULT_TIMEZONE;

function applyFavicon(href) {
  let link = document.querySelector('link[rel="icon"]');
  if (!link) { link = document.createElement("link"); link.rel = "icon"; document.head.appendChild(link); }
  link.href = href || `${process.env.PUBLIC_URL || ""}/favicon.ico`;
}

export function loadBrand(force) {
  if (!force && _cache) return Promise.resolve(_cache);
  if (!force && _promise) return _promise;
  _promise = api
    .get("/settings/brand")
    .then((r) => {
      _cache = _pick(r.data);
      applyFavicon(_cache.favicon);
      _subs.forEach((fn) => fn(_cache));
      return _cache;
    })
    .catch(() => {
      _cache = { ...EMPTY };
      return _cache;
    })
    .finally(() => {
      _promise = null;
    });
  return _promise;
}

// Push a fresh value into the cache (used right after saving in Settings).
export function setBrandCache(b) {
  _cache = _pick(b);
  applyFavicon(_cache.favicon);
  _subs.forEach((fn) => fn(_cache));
}

export function useBrand() {
  const [brand, setBrand] = useState(_cache || EMPTY);
  useEffect(() => {
    _subs.add(setBrand);
    loadBrand().then(setBrand);
    return () => {
      _subs.delete(setBrand);
    };
  }, []);
  return brand;
}
